import type { EditorView } from "prosemirror-view";
import type { Document, Msg } from "../types";
import { renderCardPreview } from "./preview";
import { PREVIEW_LINES } from "../preview-limits";

// A single shared floating popover that shows a read-only preview editor when
// hovering a card link.

let host: HTMLElement | null = null;
let inner: HTMLElement | null = null;
let view: EditorView | null = null;

function ensureHost(): { host: HTMLElement; inner: HTMLElement } {
  if (host && inner) return { host, inner };
  host = document.createElement("div");
  host.className = "card-link-popover";
  const el = document.createElement("div");
  host.appendChild(el);
  inner = el;
  document.body.appendChild(host);
  return { host, inner };
}

export function showLinkPopover(
  anchor: HTMLElement,
  content: Document,
  depth: number,
  dispatch: (msg: Msg) => void
): void {
  const { host: el, inner: slot } = ensureHost();
  const rect = anchor.getBoundingClientRect();
  el.style.left = `${rect.left}px`;
  el.style.top = `${rect.bottom + 6}px`;
  el.style.display = "block";
  view?.destroy();
  slot.textContent = "";
  view = renderCardPreview(slot, content, depth, dispatch, PREVIEW_LINES.hover);
}

let destroying = false;

export function hideLinkPopover(): void {
  if (host) host.style.display = "none";
  if (destroying) return; // guard against re-entry via the inner editor's destroy
  destroying = true;
  view?.destroy();
  view = null;
  destroying = false;
}
